import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-561166f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-item" }

import { toRefs } from 'vue';
import MessageBubble from './message-bubble.vue';
import MessageText from './message-text.vue';
import MessageImage from './message-image.vue';
import MessageVideo from './message-video.vue';
import MessageAudio from './message-audio.vue';
import MessageFile from './message-file.vue';
import MessageFace from './message-face.vue';
import MessageLocation from './message-location.vue';
import MessageMerger from './message-merger.vue';
import MessageCustom from './message-custom.vue';
import MessageTip from './message-tip.vue';
import MessageTool from './message-tool.vue';
import MessageEmojiReact from './message-emoji-react.vue';
import MessageRevoked from './message-revoked.vue';

import {
  handleTextMessageShowContext,
  handleImageMessageShowContext,
  handleVideoMessageShowContext,
  handleAudioMessageShowContext,
  handleFileMessageShowContext,
  handleFaceMessageShowContext,
  handleLocationMessageShowContext,
  handleMergerMessageShowContext,
  handleTipMessageShowContext,
  handleCustomMessageShowContext,
  isMessageTip,
} from '../utils/utils';
import { Message } from '@tencentcloud/chat';
import constant from '../../constant';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  message: {
    type: Object,
    default: () => ({}),
  },
  beforeMessage: {
    type: Object,
    default: () => ({}),
  },
  types: {
    type: Object,
    default: () => ({}),
  },
  env: {
    type: Object,
    default: () => ({}),
  },
  messageList: {
    type: Array,
    default: () => [],
  },
  // 开关控制位
  displayGroupMessageReadReceipt: {
    type: Boolean,
    default: true,
  },
  displayEmojiReactions: {
    type: Boolean,
    default: true,
  },
},
  emits: ['handleEditor', 'showDialog', 'uploading', 'jumpID','resendMessage'],
  setup(__props, { emit: emits }) {

const props = __props;




const { message, types, env, messageList, displayGroupMessageReadReceipt, displayEmojiReactions } = toRefs(props);

const handleEdit = (message: any) => {
  emits('handleEditor', message, 'reedit');
};

const handleMessage = (message: Message, type: string) => {
  if (!message || !type) {
    return;
  }
  switch (type) {
    case constant.handleMessage.forward:
      emits('showDialog', message, constant.handleMessage.forward);
      break;
    case constant.handleMessage.reference:
      emits('handleEditor', message, constant.handleMessage.reference);
      break;
    case constant.handleMessage.reply:
      emits('handleEditor', message, constant.handleMessage.reply);
      break;
    default:
      break;
  }
};

const previewImage = (message: Message) => {
  if (message) {
    emits('showDialog', message, 'previewImage');
  }
};

const showReadReceiptDialog = (message: Message) => {
  if (message) {
    emits('showDialog', message, 'receipt');
  }
};

const showRepliesDialog = (message: Message) => {
  if (message) {
    emits('showDialog', message, 'replies');
  }
};

const jumpID = (messageID: string) => {
  if (messageID) {
    emits('jumpID', messageID);
  }
};

const uploading = () => {
  emits('uploading');
};

const resendMessage = (message: Message) => {
  if (message) {
    emits('resendMessage', message);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isMessageTip)(_unref(message)))
      ? (_openBlock(), _createBlock(MessageTip, {
          key: 0,
          data: _unref(handleTipMessageShowContext)(_unref(message))
        }, null, 8, ["data"]))
      : (!_unref(message).isRevoked)
        ? (_openBlock(), _createBlock(MessageBubble, {
            key: 1,
            data: _unref(message),
            isH5: _unref(env).isH5,
            messagesList: _unref(messageList),
            needGroupReceipt: _unref(displayGroupMessageReadReceipt),
            needReplies: true,
            needEmojiReact: _unref(displayEmojiReactions),
            onJumpID: jumpID,
            onResendMessage: resendMessage,
            onShowReadReceiptDialog: showReadReceiptDialog,
            onShowRepliesDialog: showRepliesDialog
          }, {
            dialog: _withCtx(() => [
              _createVNode(MessageTool, {
                message: _unref(message),
                needEmojiReact: _unref(displayEmojiReactions),
                onHandleMessage: handleMessage
              }, null, 8, ["message", "needEmojiReact"]),
              (!_unref(env)?.isH5 && _unref(displayEmojiReactions))
                ? (_openBlock(), _createBlock(MessageEmojiReact, {
                    key: 0,
                    message: _unref(message),
                    type: "dropdown"
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (_unref(message).type === _unref(types).MSG_TEXT)
                ? (_openBlock(), _createBlock(MessageText, {
                    key: 0,
                    data: _unref(handleTextMessageShowContext)(_unref(message))
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              (_unref(message).type === _unref(types).MSG_IMAGE)
                ? (_openBlock(), _createBlock(MessageImage, {
                    key: 1,
                    isH5: _unref(env).isH5,
                    data: _unref(handleImageMessageShowContext)(_unref(message)),
                    onUploading: uploading,
                    onPreviewImage: previewImage
                  }, null, 8, ["isH5", "data"]))
                : _createCommentVNode("", true),
              (_unref(message).type === _unref(types).MSG_VIDEO)
                ? (_openBlock(), _createBlock(MessageVideo, {
                    key: 2,
                    isH5: _unref(env).isH5,
                    data: _unref(handleVideoMessageShowContext)(_unref(message)),
                    onUploading: uploading
                  }, null, 8, ["isH5", "data"]))
                : _createCommentVNode("", true),
              (_unref(message).type === _unref(types).MSG_AUDIO)
                ? (_openBlock(), _createBlock(MessageAudio, {
                    key: 3,
                    data: _unref(handleAudioMessageShowContext)(_unref(message))
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              (_unref(message).type === _unref(types).MSG_FILE)
                ? (_openBlock(), _createBlock(MessageFile, {
                    key: 4,
                    data: _unref(handleFileMessageShowContext)(_unref(message))
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              (_unref(message).type === _unref(types).MSG_FACE)
                ? (_openBlock(), _createBlock(MessageFace, {
                    key: 5,
                    data: _unref(handleFaceMessageShowContext)(_unref(message)),
                    isH5: _unref(env).isH5
                  }, null, 8, ["data", "isH5"]))
                : _createCommentVNode("", true),
              (_unref(message).type === _unref(types).MSG_LOCATION)
                ? (_openBlock(), _createBlock(MessageLocation, {
                    key: 6,
                    data: _unref(handleLocationMessageShowContext)(_unref(message))
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              (_unref(message).type === _unref(types).MSG_CUSTOM)
                ? (_openBlock(), _createBlock(MessageCustom, {
                    key: 7,
                    data: _unref(handleCustomMessageShowContext)(_unref(message))
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              (_unref(message).type === _unref(types).MSG_MERGER)
                ? (_openBlock(), _createBlock(MessageMerger, {
                    key: 8,
                    data: _unref(handleMergerMessageShowContext)(_unref(message))
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data", "isH5", "messagesList", "needGroupReceipt", "needEmojiReact"]))
        : (_openBlock(), _createBlock(MessageRevoked, {
            key: 2,
            isEdit: _unref(message).type === _unref(types).MSG_TEXT,
            data: _unref(message),
            onEdit: _cache[0] || (_cache[0] = ($event: any) => (handleEdit(_unref(message))))
          }, null, 8, ["isEdit", "data"]))
  ]))
}
}

})